<template>
	<div class="com-sgp-mid text-white">
		<div class="mid-content-top">

			<div class="centerArea">
				<div class="centerLogo">
					<div class="logoCircle">
						<img src="@/assets/images/xsd/circle.png" alt="" class="logoImg">
						<div class="logoText">六个一</div>
					</div>
				</div>
				<div class="centerStats">
					<div class="flex  justify-between">
						<div class="midLeftBox">
							<div class="centerStatItem" style="margin-left: 50px;">
								<div class="csLabel">市级评价体系</div>
								<div class="csValue">{{item.cityCount||'-'}} <span class="statUnit">套</span></div>
							</div>
							<div class="centerStatItem">
								<div class="csLabel">校级评价体系</div>
								<div class="csValue">{{item.schoolCount||'-'}} <span class="statUnit">套</span></div>
							</div>
							<div class="centerStatItem">
								<div class="csLabel">累计评价</div>
								<div class="csValue">{{item.recordCount||'-'}} <span class="statUnit">套</span></div>
							</div>
							<div class="centerStatItem" style="margin-left: 50px;">
								<div class="csLabel">活动任务数</div>
								<div class="csValue">{{item.taskCount||'-'}} <span class="statUnit">套</span></div>
							</div>
						</div>
						<div style="padding-top: 40px;">
							<div class="centerNumLaable flex align-center justify-between">
								<div>班级数</div>
								<div>{{item.classCount||'-'}}<span>个</span></div>
							</div>
							<div class="centerNumLaable flex align-center justify-between">
								<div>学生数</div>
								<div>{{item.studentCount||'-'}}<span>人</span></div>
							</div>
							<div class="centerNumLaable flex align-center justify-between">
								<div>教师数</div>
								<div>{{item.teacherCount||'-'}}<span>人</span></div>
							</div>
						</div>
						<div class="midRightBox">
							<div class="centerStatItem" >
								<div class="csLabel">参与学生数</div>
								<div class="csValue">{{item.mallStudentCount||'-'}} <span class="statUnit">名</span></div>
							</div>
							<div class="centerStatItem" style="margin-left: 50px;">
								<div class="csLabel">参与家长数</div>
								<div class="csValue">{{item.memberCount||'-'}} <span class="statUnit">名</span></div>
							</div>
							<div class="centerStatItem" style="margin-left: 50px;">
								<div class="csLabel">参与班级数</div>
								<div class="csValue">{{item.joinClassCount||'-'}} <span class="statUnit">个</span></div>
							</div>
							<div class="centerStatItem">
								<div class="csLabel">参与教师数</div>
								<div class="csValue">{{item.joinTeacherCount||'-'}} <span class="statUnit">名</span></div>
							</div>
						</div>
					</div>
					

				</div>
			</div>

			<div class="bottomStats flex align-center justify-between">
				<div class="bottomStatCard">
					<div class="bsLabel">学生参与率</div>
					<div class="bsValue">{{item.studentPercent||'-'}}%</div>
				</div>
				<div class="bottomStatCard">
					<div class="bsLabel">教师参与率</div>
					<div class="bsValue">{{item.teacherPercent||'-'}}%</div>
				</div>
				<div class="bottomStatCard">
					<div class="bsLabel">本周评价数</div>
					<div class="bsValue">{{item.recordWeekCount||'-'}}<span class="bsUnit">次</span></div>
				</div>
			</div>
		</div>
		<div class="margin-top-15">
			<BlockBox title="最新动态" enTitle="Latest Dynamics" height="319">
				<template #content>
					<div class="latestTable">
						<div class="tableHeader flex align-center">
							<div class="col-grade">年级</div>
							<div class="col-class">班级</div>
							<div class="col-evaluator">评价人</div>
							<div class="col-student">学生</div>
							<div class="col-behavior">行为</div>
							<div class="col-time">评价时间</div>
						</div>
						<div class="scrollWrapper">
							<div class="scrollContent" :style="'animation-duration:' + scrollDuration + 's'">
								<div class="tableRow flex align-center" v-for="(row, index) in recordList"
									:key="'scroll-' + index">
									<div class="col-grade">{{row.gradeName}}</div>
									<div class="col-class">{{row.className}}</div>
									<div class="col-evaluator">{{row.evaluatorName}}</div>
									<div class="col-student">{{row.studentName}}</div>
									<div class="col-behavior">{{row.itemName}}</div>
									<div class="col-time">{{row.createTimeStr}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
	</div>
</template>

<script>
	import BlockBox from '@/views/components/blockBox'
	import {
		centerDataSchool
	} from "@/api/api";

	export default {
		name: "sgpMidContent",
		components: {
			BlockBox
		},
		data() {
			return {
        item:"",
				midData: {
					citySystemCount: 1,
					schoolSystemCount: 1,
					totalEvaluation: 6631,
					activityTaskCount: 11,
					classCount: 76,
					studentCount: 3967,
					teacherCount: 219,
					participateStudentCount: 786,
					participateParentCount: 71,
					participateClassCount: 39,
					participateTeacherCount: 25,
					studentParticipationRate: '19.81%',
					teacherParticipationRate: '11.42%',
					weekEvaluationCount: 9
				},
				recordList: [],
				scrollDuration: 15,
				timerMid: null,
			}
		},
		mounted() {

		},
		beforeDestroy() {
			clearTimeout(this.timerMid);
		},
		methods: {
      init(schoolId){
        this.schoolId=schoolId;
        this.changeData();
        console.log("lefc:"+this.schoolId);
        this.timerLeft = setTimeout(() => {
          this.changeData();
        }, 60000);

      },
			async changeData() {
				try {
					const res = await centerDataSchool(this.schoolId);
					if (res && res.data) {
            this.item=res.data;
						if (res.data.recordList) this.recordList = res.data.recordList;
					}
				} catch (e) {
					console.log('使用默认数据');
				}
			}
		}
	}
</script>

<style lang="scss">
	.mid-content-top {
		// background: url('~@/assets/img/midBig001.png') no-repeat center center;
		// background-size: 100% 100%;
	}
	.centerNumLaable{
		background: url('~@/assets/img/kshBg005.png') no-repeat center center;
		background-size: 100% 100%;
		width: 240px;
		height:45px;
		margin-bottom:15px;
		padding:0 30px;
	}

	.com-sgp-mid {
		min-height: 500px;
		padding: 14px 15px 15px 15px;
		box-sizing: border-box;

		.topStats {
			.statsRow {
				.statCard {
					display: flex;
					align-items: center;
					background: rgba(20, 60, 120, 0.3);
					border-radius: 8px;
					padding: 10px 15px;
					min-width: 180px;

					.statIcon {
						width: 40px;
						height: 40px;
						margin-right: 10px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.statInfo {
						.statLabel {
							font-size: 12px;
							color: rgba(255, 255, 255, 0.6);
							margin-bottom: 4px;
						}

						.statValue {
							font-size: 22px;
							font-weight: bold;
							color: #fff;

							.statUnit {
								font-size: 12px;
								font-weight: normal;
								color: rgba(255, 255, 255, 0.6);
								margin-left: 4px;
							}
						}
					}
				}
			}
		}

		.centerArea {
			position: relative;
			height:528px;
			background: url('~@/assets/img/midBig001.png') no-repeat center center;
			background-size: 100% 100%;
			

			.centerLogo {
				position: absolute;
				top: 72%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 2;

				.logoCircle {
					width: 200px;
					height: 200px;
					position: relative;
					display: flex;
					align-items: center;
					justify-content: center;

					.logoImg {
						width: 100%;
						height: 100%;
						animation: logoRotate 20s linear infinite;
					}

					.logoText {
						position: absolute;
						font-size: 28px;
						font-weight: bold;
						color: #24bfe3;
					}
				}
			}

			@keyframes logoRotate {
				0% {
					transform: rotate(0deg);
				}

				100% {
					transform: rotate(360deg);
				}
			}

			.centerStats {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				padding-left: 50px;padding-right: 50px;
				padding-top: 30px;
				.midLeftBox{
					.centerStatItem{
						background: url('~@/assets/img/kshBg003.png') no-repeat left center;
						width: 200px;height:80px;
						background-size:200px 80px;
						padding-top: 10px;
					}
				}
				.midRightBox{
					.centerStatItem{
						background: url('~@/assets/img/kshBg004.png') no-repeat right center;
						width: 200px;height:80px;
						background-size:200px 80px;
						padding-top: 10px;
					}
				}
				.centerStatItem {
					// position: absolute;
					text-align: center;
					// background: rgba(20, 60, 120, 0.4);
					// border-radius: 20px;
					// padding: 8px 15px;
					// border: 1px solid rgba(100, 180, 255, 0.2);
					
					&.centerStatItem{margin-top: 29px;}

					.csLabel {
						font-size: 12px;
						color: rgba(255, 255, 255, 0.6);
						margin-bottom: 10px;
					}

					.csValue {
						font-size: 20px;
						font-weight: bold;
						color: #fff;

						.csUnit {
							font-size: 12px;
							font-weight: normal;
							color: rgba(255, 255, 255, 0.6);
							margin-left: 4px;
						}
					}

					&.top-left {
						top: 10px;
						left: 15%;
					}

					&.top-right {
						top: 10px;
						right: 15%;
					}

					&.mid-left {
						top: 50%;
						left: 5%;
						transform: translateY(-50%);
					}

					&.mid-right {
						top: 50%;
						right: 5%;
						transform: translateY(-50%);
					}

					&.bottom-left {
						bottom: 10px;
						left: 15%;
					}

					&.bottom-right {
						bottom: 10px;
						right: 20%;
					}

					&.bottom-far-right {
						bottom: 10px;
						right: 5%;
					}
				}
				
			}
		}

		.bottomStats {
			.bottomStatCard {
				
				text-align: center;
				padding:45px 0 25px 0;
				background:  url('~@/assets/img/kshBg002.png') no-repeat center center;
				background-size:100% 100% ;
				background-clip: border-box;
				width: 30%;

				.bsLabel {
					font-size: 15px;
					color: rgba(255, 255, 255, 0.6);
					margin-bottom: 15px;
				}

				.bsValue {
					font-size: 24px;
					font-weight: bold;
					color: #8df2ff;
					margin-top: 10px;
					.bsUnit {
						font-size: 12px;
						font-weight: normal;
						color: rgba(255, 255, 255, 0.6);
						margin-left: 4px;
					}
				}
			}
		}

		.latestTable {
			padding: 10px 15px;
			box-sizing: border-box;

			.tableHeader {
				height: 32px;
				background: rgba(20, 60, 120, 0.5);
				border-radius: 4px;
				font-weight: bold;
				font-size: 12px;
				color: #8df2ff;
				padding: 0 5px;

				.col-grade {
					flex: 1;
				}

				.col-class {
					flex: 1;
				}

				.col-evaluator {
					flex: 1;
				}

				.col-student {
					flex: 1.5;
				}

				.col-behavior {
					flex: 1.5;
				}

				.col-time {
					flex: 2;
					text-align: right;
				}
			}

			.scrollWrapper {
				height: 230px;
				overflow: hidden;
				position: relative;

				.scrollContent {
					animation: scrollUp linear infinite;

					.tableRow {
						height: 30px;
						font-size: 12px;
						border-bottom: 1px solid rgba(45, 163, 255, 0.1);
						padding: 0 5px;
						color: rgba(255, 255, 255, 0.7);

						.col-grade {
							flex: 1;
						}

						.col-class {
							flex: 1;
						}

						.col-evaluator {
							flex: 1;
						}

						.col-student {
							flex: 1.5;
						}

						.col-behavior {
							flex: 1.5;
						}

						.col-time {
							flex: 2;
							text-align: right;
						}

						&:hover {
							background: rgba(20, 60, 120, 0.3);
						}
					}
				}
			}
		}

		@keyframes scrollUp {
			0% {
				transform: translateY(0);
			}

			100% {
				transform: translateY(-50%);
			}
		}
	}
</style>